import * as actionTypes from '../actions/actionTypes';

const initialState = {
    objectives : [],
    objectiveActions : []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.STORE_ENTERPRISE_OBJECTIVES: 
          return { ...state, objectives : action.val };
        case actionTypes.GET_ENTERPRISEOBJECTIVE_ASSOCIATED_ACTIONS:
          return { ...state, objectiveActions : action.val };
        case actionTypes.RESET_OBJECTIVES: 
          return initialState;
        case actionTypes.RESET_OBJECTIVE_ACTIONS: 
          return initialState;
        default:
          break;
    }
    return state;
}